import { styled, FormHelperText, FormLabel } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import { Controller } from 'react-hook-form';

interface ControlledDateTimePickerProps {
    name: string;
    control: any;
    defaultValue?: any;
    label: string;
    error?: string;
    helperText?: string;
}

const StyledDiv = styled('div')`
    display: flex;
    align-items: center;
`;

const StyledFormLabel = styled(FormLabel)`
    margin-right: 8px;
`;


export const ControlledDateTimePicker = (props: ControlledDateTimePickerProps) => {
    const { name, control, defaultValue, label, error, helperText, ...rest } = props;

    const labelId = `${name}-label`;
    const helperTextId = `${name}-helper-text`;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({ field, fieldState }) => (
                <StyledDiv>
                    <StyledFormLabel id={labelId} htmlFor={name}>
                        {label}
                    </StyledFormLabel>
                    <DateTimePicker
                        {...rest}
                        value={field.value || defaultValue} // Ensure value is populated
                        onChange={(newValue) => field.onChange(newValue)} // Explicitly handle onChange
                        inputRef={(input) => {
                            if (input) {
                                input.id = name; // Set the id for accessibility
                                input.setAttribute('aria-labelledby', labelId); // Associate label
                                if (helperText || error) {
                                    input.setAttribute('aria-describedby', helperTextId); // Associate helper text or error
                                }
                            }
                        }}
                    />
                    {(helperText || error) && (
                        <FormHelperText id={helperTextId} error={!!error}>
                            {error || helperText}
                        </FormHelperText>
                    )}
                </StyledDiv>
            )}
        />
    );
};
